import { createStore, compose } from "redux";

import rootReducer from "./reducers";

const devCompose =
  (process.env.NODE_ENV === "development" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = createStore(rootReducer, devCompose());

export default store;
